<template>
  <div>

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <!-- TODO(adam) remove this <client-only> once we fix vue-kit css build process -->
    <client-only>
      <vk-modal
          v-if="showModal"
          :has-close-icon="false">
        <transition name="fade" mode="out-in">
          <select-location-modal
              v-if="showSelectLocationModal"
              :service="service"
              :is-city-chosen="isCityChosen"
              :is-state-chosen="isStateChosen"
              :is-zipcode-chosen="isZipcodeChosen"
              :zipcode="$route.params.zipcode"
              @zipcode-chosen="handleZipcodeChosen"
              @location-chosen="$store.commit('jobrequest/setLocation', $event)"/>
          <service-unavailable-modal
              v-else-if="showServiceUnavailableModal"
              :service="service"
              :zipcode="$route.params.zipcode"
              @ok="$router.push({ name: 'homepage' })"/>
        </transition>
      </vk-modal>
    </client-only>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SelectLocationModal from './components/SelectLocationModal';
import ServiceUnavailableModal from './components/ServiceUnavailableModal';

export default {
  name: 'job-request-view',
  components: {
    SelectLocationModal,
    ServiceUnavailableModal,
  },
  props: {
    isZipcodeChosen: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('jobrequest', [
      'isCityChosen',
      'isStateChosen',
      'isServiceAvailable',
      'service',
      'location',
    ]),
    isLocationChosen () {
      return this.isCityChosen && this.isStateChosen;
    },
    showSelectLocationModal () {
      return !this.isZipcodeChosen || (this.isServiceAvailable && !this.isLocationChosen);
    },
    showServiceUnavailableModal () {
      return !this.isServiceAvailable;
    },
    showModal () {
      const shouldShowModal = this.showSelectLocationModal || this.showServiceUnavailableModal;
      return shouldShowModal;
    },
  },
  mounted () {
    const { service, location } = this;
    this.$events.$emit(this.$events.REQUEST_ENTER_FLOW, {
      ...service,
      ...location,
      zipcode: this.$route.params.zipcode,
    });
  },
  methods: {
    handleZipcodeChosen ($event) {
      this.$router.push({
        params: { zipcode: $event.zipcode },
        query: { city: $event.city, state: $event.state },
      }, () => {
        // TODO(adam): this is necessary to run the main job request mounted hook again
        // TODO(adam): the main mounted hook should be a beforeRouteUpdate()
        window.location.reload();
      });
    },
  },
};
</script>
